import { useSearchParams } from "react-router-dom";

import { URL_PARAMS } from "@/constants/urlParams";

export const usePageSizeSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const pageSize = Number.parseInt(searchParams.get(URL_PARAMS.PAGE_SIZE) || "10", 10);

  const setPageSize = (pageSize: number) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set(URL_PARAMS.PAGE_SIZE, pageSize.toString());
    // Reset to page 1 when changing page size
    newParams.set(URL_PARAMS.PAGE, "1");
    setSearchParams(newParams);
  };

  const resetPageSize = () => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete(URL_PARAMS.PAGE_SIZE);
    setSearchParams(newParams);
  };

  return {
    pageSize,
    resetPageSize,
    setPageSize
  };
}; 